import { Injectable } from '@angular/core';
import { CalculationService } from '../../calculation.service';
import { CalculationStorageService } from '../../../../../shared/services/calculation-storage.service';

@Injectable()
export class AdditionalDataService {

  constructor(private logicService: CalculationService,
              private calculationStorageService: CalculationStorageService) {
  }

  public changeVinNumber(vin: string): void {
    this.logicService.vehicleData.vin = vin;
    this.calculationStorageService.updateCalculation();
  }

}
